module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "inline-form-group"
  }, [_c('el-form-item', {
    attrs: {
      "label": "Wyświetl filtry",
      "error": _vm.errors['show_filter_bar']
    }
  }, [_c('el-switch', {
    model: {
      value: (_vm.form.show_filter_bar),
      callback: function($$v) {
        _vm.$set(_vm.form, "show_filter_bar", $$v)
      },
      expression: "form.show_filter_bar"
    }
  })], 1)], 1), _vm._v(" "), _c('el-collapse', {
    staticClass: "formset__list"
  }, _vm._l((_vm.form.sections), function(section, i) {
    return _c('div', {
      staticClass: "formset__item"
    }, [_c('el-collapse-item', {
      attrs: {
        "name": i
      }
    }, [_c('template', {
      slot: "title"
    }, [_c('formset-header', {
      attrs: {
        "label": ("" + (_vm.getCategoryName(section.category) || 'Nowa sekcja')),
        "items": _vm.form.sections,
        "errors": _vm.checkForErrors(_vm.errors.sections, [i]),
        "index": i
      },
      on: {
        "update:items": function($event) {
          return _vm.$set(_vm.form, "sections", $event)
        }
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "inline-form-group"
    }, [_c('el-form-item', {
      attrs: {
        "label": "Kolor tła",
        "error": _vm.errors.sections && _vm.errors.sections[i]['bg_color']
      }
    }, [_c('el-color-picker', {
      model: {
        value: (section.bg_color),
        callback: function($$v) {
          _vm.$set(section, "bg_color", $$v)
        },
        expression: "section.bg_color"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "Kolor tekstu",
        "error": _vm.errors.sections && _vm.errors.sections[i]['text_color']
      }
    }, [_c('el-color-picker', {
      model: {
        value: (section.text_color),
        callback: function($$v) {
          _vm.$set(section, "text_color", $$v)
        },
        expression: "section.text_color"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "Wyświetlaj pasek filtrów",
        "error": _vm.errors.sections && _vm.errors.sections[i]['show_tags_bar']
      }
    }, [_c('el-switch', {
      model: {
        value: (section.show_tags_bar),
        callback: function($$v) {
          _vm.$set(section, "show_tags_bar", $$v)
        },
        expression: "section.show_tags_bar"
      }
    })], 1)], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "Edycja",
        "error": _vm.errors.sections && _vm.errors.sections[i]['edition'],
        "required": ""
      }
    }, [_c('el-select', {
      attrs: {
        "filterable": "",
        "placeholder": "Edycja"
      },
      model: {
        value: (section.edition),
        callback: function($$v) {
          _vm.$set(section, "edition", $$v)
        },
        expression: "section.edition"
      }
    }, _vm._l((_vm.$store.state.editions), function(edition) {
      return _c('el-option', {
        key: edition.id,
        attrs: {
          "label": edition.year,
          "value": edition.id
        }
      })
    }), 1)], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "Kategoria",
        "error": _vm.errors.sections && _vm.errors.sections[i]['category']
      }
    }, [_c('el-select', {
      staticClass: "fluid",
      attrs: {
        "filterable": "",
        "placeholder": "Kategoria"
      },
      model: {
        value: (section.category),
        callback: function($$v) {
          _vm.$set(section, "category", $$v)
        },
        expression: "section.category"
      }
    }, _vm._l((_vm.categories), function(item) {
      return _c('el-option', {
        key: item.id,
        attrs: {
          "label": item.name_pl,
          "value": item.id
        }
      })
    }), 1)], 1)], 2)], 1)
  }), 0), _vm._v(" "), _c('el-button', {
    staticClass: "fluid",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addSection
    }
  }, [_vm._v("\n        Dodaj sekcję\n    ")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5812b60a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/forms/StandsWidget.vue
// module id = 759
// module chunks = 0